import { render, staticRenderFns } from "./deviceChange.vue?vue&type=template&id=5332ec6c&scoped=true&"
import script from "./deviceChange.vue?vue&type=script&lang=js&"
export * from "./deviceChange.vue?vue&type=script&lang=js&"
import style0 from "./deviceChange.vue?vue&type=style&index=0&id=5332ec6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332ec6c",
  null
  
)

export default component.exports